import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router";
import ButtonPage from "../../comman/button/ButtonPage";
import "./NodatafoundPage.css";

export default function NodatafoundPage(props) {
  const navigate = useNavigate();
  return (
    <div className={`${props.className} nodata_found`}>
      <div className={"card"}>
        <div className={"card-body"}>
          <LazyLoadImage
            alt={""}
            className={"mb-3"}
            src={props.image}
          ></LazyLoadImage>
          <h5>{props?.title}</h5>
          <p>{props?.description}</p>
          {props?.button && (
            // <button
            //   onClick={() =>
            //     props?.navigation === false
            //       ? props?.onClick()
            //       : navigate(props?.navigation)
            //   }
            //   className={"btn-submit"}
            // >
            //   {props?.button}
            // </button>
            <ButtonPage
              Text={props?.button}
              onClick={() =>
                    props?.navigation === false
                      ? props?.onClick()
                      : navigate(props?.navigation)
                  }
              className={"button-submit"}
              type="button"
            />
          )}
        </div>
      </div>
    </div>
  );
}
